/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import 'moment/locale/en-gb';
import 'moment/locale/vi';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';
import './index.scss';

import Action_logs from '../../assets/icons/Action_logs.svg';
import Group_Members from '../../assets/icons/Group_Members.svg';
import Members from '../../assets/icons/Members.svg';
import Whitelist_Device from '../../assets/icons/Whitelist_Device.svg';
import Whitlist_IP from '../../assets/icons/Whitlist_IP.svg';

import NotificationsTab from './Notifications';
import { ActionLog } from './ActionLog';
import GroupMembersTab from './GroupMembers';
import MembersTab from './Members';
import WhitelistIPTab from './WhitelistIP';
import WhitelistDeviceTab from './WhitelistDevice';

const { TabPane } = Tabs;

const SystemPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    dataUser,
    accountByNamespace,
    isAuth,
    namespace: localNamespace,
    userId,
  } = useSelector((state) => state);

  const [isAdmin, setIsAdmin] = useState(false);
  const [currentTab, setCurrentTab] = useState('notifications');
  const [groupSearchKeyword, setGroupSearchKeyword] = useState('');
  const [namespace, setNamespace] = useState();

  const onNavigateToGroup = (groupName) => {
    setCurrentTab('group-members');
    setGroupSearchKeyword(groupName);
  };

  useEffect(() => {
    if (localNamespace) {
      setNamespace(localNamespace);
    }
  }, [localNamespace]);

  useEffect(() => {
    if (isAuth === 1 && namespace) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_ACCOUNT_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAuth, namespace]);

  useEffect(() => {
    if (accountByNamespace && userId) {
      const adminRole = accountByNamespace.some(
        (account) => account.accountId === userId && account.role === 'admin',
      );

      if (adminRole) {
        setIsAdmin(true);
        return;
      }
    }
    if (dataUser) {
      const adminRole =
        dataUser.role === 'admin' ||
        (dataUser.role === 'member' && dataUser.detailRole === 'operator');

      if (adminRole) {
        setIsAdmin(true);
        return;
      }
    }
    setIsAdmin(false);
  }, [accountByNamespace, userId, dataUser]);

  return (
    <div className="system-component">
      <Tabs
        size="large"
        tabPosition="left"
        activeKey={currentTab}
        onChange={(value) => setCurrentTab(value)}
      >
        <TabPane
          tab={
            <span style={{ fontSize: '14px' }}>
              <img
                className="system-icon"
                alt="Action-notification"
                src={Action_logs}
              />
              {t('Notification')}
            </span>
          }
          key="notifications"
        >
          <NotificationsTab
            namespace={namespace}
            localNamespace={localNamespace}
            isAuth={isAuth}
            currentTab={currentTab}
          />
        </TabPane>
        <TabPane
          tab={
            <span style={{ fontSize: '14px' }}>
              <img
                className="system-icon"
                alt="Action-logs"
                src={Action_logs}
              />
              {t('Action logs')}
            </span>
          }
          key="logs"
        >
          <ActionLog />
        </TabPane>
        {isAdmin && (
          <TabPane
            tab={
              <span style={{ fontSize: '14px' }}>
                <img
                  className="system-icon"
                  alt="Group-Members"
                  src={Group_Members}
                />
                {t('Group Members')}
              </span>
            }
            key="group-members"
          >
            <GroupMembersTab
              namespace={namespace}
              isAdmin={isAdmin}
              currentTab={currentTab}
              searchKeyword={groupSearchKeyword}
              setSearchKeyword={setGroupSearchKeyword}
            />
          </TabPane>
        )}
        {isAdmin && (
          <TabPane
            forceRender
            tab={
              <span style={{ fontSize: '14px' }}>
                <img className="system-icon" alt="Members" src={Members} />
                {t('Members')}
              </span>
            }
            key="member"
          >
            <MembersTab
              namespace={namespace}
              localNamespace={localNamespace}
              isAdmin={isAdmin}
              currentTab={currentTab}
              userId={userId}
              onNavigateToGroup={onNavigateToGroup}
            />
          </TabPane>
        )}
        <TabPane
          disabled={!isAdmin}
          tab={
            <span style={{ fontSize: '14px' }}>
              <img
                className="system-icon"
                alt="Whitlist-IP"
                src={Whitlist_IP}
              />
              {t('Whitelist IP')}
            </span>
          }
          key="white-list"
        >
          <WhitelistIPTab
            namespace={namespace}
            isAdmin={isAdmin}
            isAuth={isAuth}
            currentTab={currentTab}
          />
        </TabPane>
        <TabPane
          disabled={!isAdmin}
          tab={
            <span style={{ fontSize: '14px' }}>
              <img
                className="system-icon"
                alt="Whitelist-Device"
                src={Whitelist_Device}
              />
              {t('Whitelist Device')}
            </span>
          }
          key="white-list-device"
        >
          <WhitelistDeviceTab
            namespace={namespace}
            isAdmin={isAdmin}
            isAuth={isAuth}
            currentTab={currentTab}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default SystemPage;
